import { useRef, useState } from 'react';
import { Button } from '../ui/button';

export const SignaturePad = ({ onChange, disabled = false }) => {
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [hasInk, setHasInk] = useState(false);

  const point = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const src = e.touches?.[0] || e;
    const scaleX = canvasRef.current.width / rect.width;
    const scaleY = canvasRef.current.height / rect.height;
    return { x: (src.clientX - rect.left) * scaleX, y: (src.clientY - rect.top) * scaleY };
  };

  const start = (e) => {
    if (disabled) return;
    const ctx = canvasRef.current.getContext('2d');
    const { x, y } = point(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
    setDrawing(true);
  };

  const move = (e) => {
    if (!drawing) return;
    const ctx = canvasRef.current.getContext('2d');
    const { x, y } = point(e);
    ctx.lineTo(x, y);
    ctx.strokeStyle = '#0F172A';
    ctx.lineWidth = 2.2;
    ctx.lineCap = 'round';
    ctx.stroke();
    setHasInk(true);
  };

  const end = () => {
    if (!drawing) return;
    setDrawing(false);
    if (hasInk) onChange(canvasRef.current.toDataURL('image/png'));
  };

  const clear = () => {
    const c = canvasRef.current;
    c.getContext('2d').clearRect(0, 0, c.width, c.height);
    setHasInk(false);
    onChange(null);
  };

  return (
    <div className="rounded-xl border-2 border-slate-200 bg-white p-3" data-testid="signature-pad">
      <canvas ref={canvasRef} width={600} height={200} data-testid="signature-canvas"
        className="w-full h-40 rounded-lg border border-dashed border-slate-300 bg-[#FCFCFB] cursor-crosshair touch-none"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
      <div className="flex justify-between items-center mt-2">
        <p className="text-xs text-slate-500">Sign inside the box using your mouse or finger</p>
        <Button type="button" variant="ghost" size="sm" onClick={clear} disabled={disabled} data-testid="signature-clear-btn">Clear</Button>
      </div>
    </div>
  );
};
